import { useEffect, useRef } from "react";
const useReturnFocus = (active) => {
    const focusRef = useRef();
    useEffect(() => {
        const returnFocus = () => {
            var _a;
            (_a = focusRef.current) === null || _a === void 0 ? void 0 : _a.focus();
            focusRef.current = undefined;
        };
        if (active && document.activeElement) {
            focusRef.current = document.activeElement;
        }
        else if (!active) {
            returnFocus();
        }
        return returnFocus;
    }, [active]);
};
export default useReturnFocus;
//# sourceMappingURL=useReturnFocus.js.map